export default __webpack_public_path__ + "static/media/ios.d75fe7bb.svg";